import borders from "../../base/borders";
import boxShadows from "../../base/boxShadows";

const { borderRadius } = borders;
const { "2xl": xxl } = boxShadows;

const dialog = {
  defaultProps: {
    scroll: "paper" as const,
  },
  styleOverrides: {
    paper: ({ theme }: { theme: any }) => ({
      borderRadius: borderRadius.lg,
      boxShadow: xxl,
      border: `${theme.borders.borderWidth[1]} solid ${theme.palette.divider}`,
      overflow: "hidden",
      backgroundColor: theme.palette.background.paper,
      backgroundImage: "none",
    }),
    paperFullScreen: ({ theme }: { theme: any }) => ({
      borderRadius: 0,
      border: "none",
      boxShadow: "none",
      backgroundColor: theme.palette.background.paper,
    }),
  },
};

export default dialog;
